import { Stack, Button } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import FilterDatePicker from 'src/components/filter-form/filter-date-picker';
import Iconify from 'src/components/iconify';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { TopupFilters, TopupFilterKey, TopupFilterValue } from 'src/type/topup-deposit';

type Props = {
  filters: TopupFilters;
  onFilters: (name: TopupFilterKey, value: TopupFilterValue) => void;
  dateError: boolean;
  disabledSearch?: boolean;
  enableCreate?: boolean;
  onCreateTopup?: VoidFunction;
};

export default function TopupTableToolbar({
  filters,
  onFilters,
  dateError,
  disabledSearch,
  enableCreate,
  onCreateTopup,
}: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        width: 1,
      }}
    >
      <FilterDatePicker
        label="จากวันที่"
        value={filters.startDate}
        onChange={handleFilterStartDate}
      />
      <FilterDatePicker
        label="ถึงวันที่"
        value={filters.endDate}
        onChange={handleFilterEndDate}
        dateError={dateError}
      />

      {!disabledSearch && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          flexGrow={1}
          sx={{ width: { xs: 1, md: 'auto', minWidth: 140 } }}
        >
          <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
        </Stack>
      )}

      {enableCreate && (
        <Stack
          direction="row"
          spacing={2}
          sx={{ ml: { md: 'auto' } }}
          alignItems="center"
          width={{ xs: 1, md: 'auto' }}
        >
          <Button
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={onCreateTopup}
            sx={{ width: { xs: 1, md: 250 } }}
          >
            สร้างรายการวงเงินหลักประกัน
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
